import React, { useRef } from "react";

export default function Weight({ onChange }) {
  const [displayValue, setDisplayValue] = React.useState("");
  const inputRef = useRef(null);

  const handleChange = (event) => {
    const newDisplayValue = event.target.value;
    const filteredDisplayValue = newDisplayValue
      .replace(/[^0-9,]/g, "")
      .replace(/(,.*),/g, "$1");

    setDisplayValue(filteredDisplayValue);
    onChange(Number(filteredDisplayValue.replace(",", ".")));
  };

  return (
    <div
      className=""
      onClick={() => inputRef.current && inputRef.current.focus()}
    >
      <div
        className="text-sm sm:text-base mb-2 cursor-default"
        id="weightLabel"
      >
        Votre poids
      </div>
      <div className="flex items-center gap-2">
        <input
          ref={inputRef}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
          onChange={handleChange}
          value={displayValue}
          aria-labelledby="weightLabel"
          aria-describedby="weightDescription"
          role="spinbutton"
          aria-valuenow={displayValue}
        />
        <div className="text-base sm:text-xl font-bold cursor-default">kg</div>
        <div id="weightDescription" className="hidden">
          Entrez votre poids en kilogrammes. Utilisez une virgule pour les
          décimales.
        </div>
      </div>
    </div>
  );
}
